import { useAdminOrganizationEditorNotesActions } from 'slices/admin/organization/editorNotesSlice';
import { useSelector } from 'react-redux';

export default () => {
  const actions = useAdminOrganizationEditorNotesActions();
  const data = useSelector((state) => state.adminOrganizationEditorNotesReducer);

  return { ...data, ...actions };
};
